import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import pt from 'vuetify/lib/locale/pt'
import en from 'vuetify/lib/locale/en'
import es from 'vuetify/lib/locale/es'

const messages = {
  en: {
    $vuetify: en
  },
  es: {
    $vuetify: es
  },
  pt: {
    $vuetify: pt
  },
}
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const l = getCookie("TMT[lang]");


function getPrimaryColor() {
  const currentUrl = window.location.pathname;
  return currentUrl.includes('/app') ? '#0e1439' : '#344980';
}

Vue.use(Vuetify);
const i18n = new VueI18n({
  locale: l ? l.split('-')[0] : 'es', 
  messages, 
})
export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      light: {
        primary: getPrimaryColor(),
        secondary: '#707070', 
        accent: '#4c4c4c', 
        grey: '#919496'
      },
    },
  },
});
